import { render, staticRenderFns } from "./AboutHomeItem.vue?vue&type=template&id=1a388296&scoped=true&"
import script from "./AboutHomeItem.vue?vue&type=script&lang=js&"
export * from "./AboutHomeItem.vue?vue&type=script&lang=js&"
import style0 from "./AboutHomeItem.vue?vue&type=style&index=0&id=1a388296&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a388296",
  null
  
)

export default component.exports